import AppDispatcher from '../core/AppDispatcher.jsx';
import { EventEmitter } from 'events';
import ApplicationConstants from '../constants/ApplicationConstants';
import AccountTypeConstants from '../constants/AccountTypeConstants';

const CHANGE_EVENT = 'change';
const ApplicationActionTypes = ApplicationConstants.ActionTypes;

let _showNotifiction = false;

const resetShowNotification = () => _showNotifiction = false;
const enableShowNotification = () => _showNotifiction = true;
const toggleShowNotification = () => _showNotifiction = !_showNotifiction;

class SaveApplicationNotificationStoreClass extends EventEmitter {
    constructor() {
        super();
    }

    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }

    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }

    emitChange() {
        return this.emit(CHANGE_EVENT);
    }

    getShowNotifiction() {
        return _showNotifiction;
    }
}

// Initialize the singleton to register with the
// dispatcher and export for React components
const SaveApplicationNotificationStore = new SaveApplicationNotificationStoreClass();

// Register each of the actions with the dispatcher
// by changing the store's data and emitting a change
SaveApplicationNotificationStore.dispatchToken = AppDispatcher.register((action) => {

    switch (action.actionType) {

        case AccountTypeConstants.ActionTypes.SELECT_ACCOUNT_TYPE:
            resetShowNotification();
            break;
                
        case ApplicationActionTypes.SHOW_ERROR_BAR:
            resetShowNotification();
            break;
            
        case ApplicationActionTypes.TRANSITION_COMPLETED:
            resetShowNotification();
            break;
            
        case ApplicationActionTypes.SET_PRODUCT_ID:
            resetShowNotification();
            break;
            
        case ApplicationActionTypes.APPLICATION_SAVE_SUCCESS:
            enableShowNotification();
            break;

        case ApplicationActionTypes.TOGGLE_SAVE_APPLICATION_NOTIFICATION:
            toggleShowNotification();
            break;

        default:
            return true;
    }

    SaveApplicationNotificationStore.emitChange();
    return true;
});

export default SaveApplicationNotificationStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/SaveApplicationNotificationStore.js